import { extend } from 'flarum/common/extend';
const SEARCH_MODAL = 'flarum/common/components/SearchModal';

/**
 * Search window: no technical cheat sheet. The "Параметры поиска" block (status:, author:,
 * created:, tag: with their + / − controls) and the "Предпросмотр поиска" heading are not shown;
 * the typed syntax still works — only these hints are left out of the UI.
 */
export default function addSearchLayout() {
  extend(SEARCH_MODAL, 'activeTabItems', function (items) {
    items.remove('gambits');
    if (!items.has('results')) return;

    // results section: <div> [<hr>, <ul> [<li.Dropdown-header>Предпросмотр поиска</li>, …]]
    const list = (items.get('results')?.children || []).find(child => child?.tag === 'ul');
    const first = list?.children?.[0];
    if (first?.tag === 'li' && /\bDropdown-header\b/.test(first.attrs?.className || '')) list.children[0] = null;
  });
}